
import { Box, Typography, Paper } from '@mui/material';
import Grid from '@mui/material/Grid2';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

/* ----------  progress bar ---------- */
const StyledBar = styled(LinearProgress)(({ color }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: '#f0f0f0',
  '& .MuiLinearProgress-bar': { borderRadius: 4, backgroundColor: color },
}));



/* ----------  row ---------- */
const Row = ({ label, score, color }) => {
  const safe = Number.isFinite(+score) ? Math.max(0, Math.min(100, +score)) : 0;
  return (
    <Box sx={{ mb: 1.5 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body1" fontSize="0.875rem" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body1" fontSize="0.875rem" fontWeight={600}>
          {Math.round(safe)}%
        </Typography>
      </Box>
      <StyledBar variant="determinate" value={safe} color={color} />
    </Box>
  );
};



/* ---------- component ---------- */
const EmotionAnalysis = ({ emotionAnalysis = {} }) => {
  const pct = (n) => (Number.isFinite(+n) ? Math.max(0, Math.min(100, +n)) : 0);

  const rows = [
    { label: 'Happiness',   key: 'Happiness',   color: '#10B981' },
    { label: 'Confidence',  key: 'Confidence',  color: '#EAB308' },
    { label: 'Calmness',    key: 'Calmness',    color: '#3B82F6' },
    { label: 'Empathy',     key: 'Empathy',     color: '#A855F7' },
    { label: 'Frustration', key: 'Frustration', color: '#EF4444' },
  ];
  
  return (
    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2, flex: 1 }}>
        <Typography variant="h6" fontWeight={600} fontSize="1.125rem" mb={2}>
          Emotion Analysis
        </Typography>

        {rows.map(({ label, key, color }) => (
          <Row key={key} label={label} score={pct(emotionAnalysis[key])} color={color} />
        ))}
      </Paper>
    </Grid>
  );
};

export default EmotionAnalysis;